<template>
    <div id="tryout-chooser">
        <v-btn
            id="tryout_chooser_tambah"
            block
            class="font-weight-bold dark--text"
            depressed
            color="#FAFAFA"
            style="
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
                border-radius: 4px;
            "
            @click="newInitData()"
            >Tambah Tryout</v-btn
        >

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-text width="100%">
                        <app-datatable
                            :items="rows"
                            :headers="headers"
                            :has-custom-pagination="true"
                            :custom-pagination-per-page="pagination.perPage"
                            :custom-pagination-current-page="
                                pagination.currentPage
                            "
                            :hasAction="false"
                            v-on:dblClicked="tryoutSelected($event)"
                        ></app-datatable>
                    </v-card-text>
                    <v-card-text>
                        <div class="text-h2"></div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<style>
.modal-body {
    overflow: auto;
}
</style>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "tryout-chooser",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    props: ["isInstant"],

    data: function () {
        return {
            isLoading: false,
            showModal: false,
            headers: [
                { text: "Judul", value: "name" },
                { text: "Level", value: "level" },
                { text: "Durasi", value: "duration" },
                { text: "Jml. Soal", value: "itemCount" },
                { text: "Mata Pelajaran", value: "subtests" },
                { text: "Mulai", value: "startDate" },
                { text: "Berakhir", value: "endDate" },
            ],
            headersKey: [
                "name",
                "level",
                "duration",
                "itemCount",
                "subtests",
                "startDate",
                "endDate",
            ], // camel case for matching search with API
            rows: [],
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 15,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
        };
    },

    watch: {
        // pagination: function () {
        //   this.reloadDataAndOpenModal();
        // },
    },

    methods: {
        tryoutSelected: function (tryout) {
            this.$emit("selected", tryout);
            this.showModal = false;
        },

        newInitData: function () {
            this.search = null;
            this.pagination = {
                perPage: 15,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            };
            this.reloadDataAndOpenModal();
        },

        reloadDataAndOpenModal: function () {
            this.isLoading = true;
            var context = this;
            var search = this.search;
            var pagination = {
                perPage: this.pagination.perPage,
                currentPage: this.pagination.currentPage,
                sortMode: this.pagination.sortMode,
            };

            TryoutService.getListPublishedTryout(
                pagination,
                search,
                function (result) {
                    context.rows.splice(0, context.rows.length);
                    if (result.success) {
                        result.data.forEach(function (tryout, index) {
                            if (context.isInstant && !tryout.is_repeated)
                                return;

                            if (!tryout.group_id) {
                                var subjects = "";
                                var jmlSoal = 0;
                                tryout.subtests.forEach(function (subtest) {
                                    subjects += subtest.subject_name + ",";
                                    jmlSoal += subtest.item_count;
                                });

                                var start =
                                    tryout.start_date + " " + tryout.start_time;
                                var end =
                                    tryout.end_date + " " + tryout.end_time;
                                var row = {
                                    id: tryout.id,
                                    no: index,
                                    name: tryout.name,
                                    level: tryout.level,
                                    duration: tryout.duration,
                                    jmlSoal: jmlSoal,
                                    subjects: subjects,
                                    start: start,
                                    end: end,
                                };
                                context.pagination.totalPages = tryout.page;
                                context.rows.push(row);
                            }
                        });

                        context.isLoading = false;
                        context.showModal = true;
                    }
                },
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// TryoutChooser.vue?195e88da